import {useForm} from "react-hook-form";
import {useAcceptJS} from "../shared/UseAcceptJS";
import React, {useEffect, useState} from "react";
import {publicCustomerService} from "../services/publicCustomerService";
import notificationService from "../services/NotificationService";
import {authorize_net_client_key, authorize_net_login_id} from "../services/common.services";
import TableWithActionsDropdown, {Column} from "../shared/components/TableWithActionsDropdown";
import {Dropdown} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import KeywordDropdownSearchForm from "../shared/components/KeywordDropdownSearchForm";
import {userService} from "../services/userService";
import ConfirmationModal from "../components/ConfirmationModal";
import ProcessAllModal from "../components/web-not-run/ProcessAllModal";
import PopoverLink from "../shared/components/PopoverLink";
import {batchPaymentService} from "../services/batchPaymentsService";

const WebNotRunPage: React.FC = () => {
    const navigate = useNavigate()
    const { register, reset, getValues, watch} = useForm();
    const [searchKeywords, setSearchKeywords] = useState([])
    const [webNotRunData, setWebNotRunData] = useState([])
    const [paymentData, setPaymentData] = useState(null)
    const [dropDownOptions, setDropdownOptions] = useState(["Web Not Run", "Web Run Failed", "All"])
    const [activeDropdown, setActiveDropdown] = useState("All")
    const [showProcessModal, setShowProcessModal] = useState(false)
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)

    const onSearch = () => {
        batchPaymentService.getWebNotRun().then(r => {
            setWebNotRunData(r)
        })
    }

    useEffect(() => {
        onSearch();
    }, []);
    
    function runPayments(idsToRun: number[] = []) {
        setShowProcessModal(true);
        batchPaymentService.processCards(idsToRun).then(r => {
            setPaymentData(r)
        })
    }

    const columns: Column<any>[] = [
        { label: "Name", varName: "name", render: (a) => `${a.firstName ?? ''} ${a.lastName}` },
        { label: "Date Completed", varName: "dateDone", render: (a) => {return new Date(a.dateDone).toLocaleDateString('en-US', {timeZone: 'UTC', month: '2-digit', day: '2-digit', year: 'numeric',})}},
        { label: "Amount", varName: "totalJobPrice", render: (a) => `$${a.totalJobPrice}`},
        { label: "Status", varName: "jobStatusName", render: (a) => {
                if(a.lastErrorMessage) {
                    return (
                        <>
                            Web Run Failed {' '}
                            <PopoverLink lastErrorMessage={a.lastErrorMessage} linkText={'Why?'}/>
                        </>
                    )
                } else {
                    return 'Web Not Run'
                }
        }},
    ];
        
    return (
        <>
            <div className="container-fluid ptCustom">

                <div className="row">
                    <div className="col-12 my-2">
                        <div className="card shadow-sm rounded-lg">
                            <div className="card-body p-4">
                                {/*<KeywordDropdownSearchForm searchKeywords={searchKeywords}
                                   DropdownOptions={dropDownOptions} onSearch={onSearch}
                                   setSearchKeywords={setSearchKeywords}
                                   activeDropdown={activeDropdown}
                                   setActiveDropdown={setActiveDropdown}
                                />*/}
                                <div className="card no-shadow">
                                    <div className="estimatesTable">
                                        <TableWithActionsDropdown
                                            data={webNotRunData} 
                                            columns={columns}
                                            headerHTML={() => (
                                                <button onClick={() => setShowConfirmationModal(true)}
                                                        className="btn btn-secondary px-4 py-2">
                                                    <h3 className="mb-0">Process all</h3>
                                                </button>
                                            )}
                                            actions={(data) => (
                                                <>
                                                    <Dropdown.Item onClick={() => {runPayments([data.jobId])}}>
                                                        <i className="fa-light fa-credit-card"></i> Process
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => {navigate('/admin/customer-details', {
                                                        state: {
                                                            customerId: data.customerId,
                                                            customerName: data.customerName,
                                                            propertyAddress: data.propertyAddress,
                                                        }
                                                    });}}>
                                                        <i className="fa-light fa-eye"></i> View Customer
                                                   </Dropdown.Item>
                                                </>
                                              )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <ConfirmationModal show={showConfirmationModal} toggle={() => setShowConfirmationModal(false)} onConfirm={() => {
                runPayments([])
            }} cardText={'Are you sure you want to process all cards?'} confirmButtonText={'Yes, process all'}/>
            <ProcessAllModal show={showProcessModal} toggle={() => setShowProcessModal(false)} refreshData={onSearch} data={paymentData}/>
        </>
    )
}

export default WebNotRunPage